/* Model */
class UserModel extends App.Models.BaseModel {
    modelUrl = 'Users';

    searchWithCriteria = (obj) => {
        return Monet.Model.searchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.User = UserModel;
